import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'eo-paginator',
  templateUrl: './eo-paginator.component.html',
  styleUrl: './eo-paginator.component.scss',
})
export class EoPaginatorComponent {
  @Input() currentPage = 0;
  @Input() pagesize = 0;
  @Input() totalCount = 0;

  @Output() pageChange = new EventEmitter<PaginatorState>();

  onPageChange(event: PaginatorState): void {
    this.pageChange.emit(event);
  }
}
